import { AccreditationStatusEnumType } from '__generated__/graphql';

export default function accreditationStatusToReadable(role: AccreditationStatusEnumType): {
  label: string;
  color: string;
} {
  switch (role) {
    case AccreditationStatusEnumType.NotAccredited:
      return {
        label: 'Not Accredited',
        color: 'red',
      };
    case AccreditationStatusEnumType.PendingInvestorResponse:
      return {
        label: 'Pending Investor Response',
        color: 'gray',
      };
    case AccreditationStatusEnumType.InitiateProcess:
      return {
        label: 'Initiate Process',
        color: 'amber',
      };
    case AccreditationStatusEnumType.PendingAlindiaVerification:
      return {
        label: 'Pending AL India Verification',
        color: 'orange',
      };
    case AccreditationStatusEnumType.Accredited:
      return {
        label: 'Accredited',
        color: 'green',
      };
    default:
      return {
        label: role,
        color: 'gray',
      };
  }
}
